import React from 'react';
import PropTypes from 'prop-types';
import { MenuGroup } from '@fluentui/react-components';

function DatasetSectionGroup({
  sectionHeader,
  children,
}) {
  return (<MenuGroup>
    {sectionHeader}
    {children}
  </MenuGroup>);
}

DatasetSectionGroup.propTypes = {
  sectionHeader: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default DatasetSectionGroup;
